module.exports = __webpack_public_path__ + "img/icon_t16.98b33de1.png";